import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { SpinnerLoader, Typography } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { useCreditUsageSourcesContext } from 'pages/analytics/pages/creditUsage/pages/sources/context/creditUsageSourcesContext'
import styles from './styles.module.scss'

export const SourcesSummary = observer(() => {
  const { sourcesSummaryStore } = useCreditUsageSourcesContext()
  const { summary, loading } = sourcesSummaryStore

  if (loading)
    return <SpinnerLoader wrapperClassName={styles.totalSpinner} ariaLabel='SourcesSummary' />

  if (!summary) return null

  return (
    <div className={styles.grid}>
      <div className={classNames(styles.cell, styles.messages)}>
        <Typography variant={'body-rg-regular'} color={'tertiary'} ariaLabel={'TotalMessagesLabel'}>
          {'Total messages'}
        </Typography>
        <Typography variant={'heading-lg'} ariaLabel={'TotalMessagesValue'}>
          {numberFormat({ value: summary.messages })}
        </Typography>
      </div>

      <div className={classNames(styles.cell, styles.calls)}>
        <Typography variant={'body-rg-regular'} color={'tertiary'} ariaLabel={'TotalCallsLabel'}>
          {'Total calls'}
        </Typography>
        <Typography variant={'heading-lg'} ariaLabel={'TotalCallsValue'}>
          {numberFormat({ value: summary.calls })}
        </Typography>
      </div>

      <div className={classNames(styles.cell, styles.credits)}>
        <Typography variant={'body-rg-regular'} color={'tertiary'} ariaLabel={'TotalCreditsLabel'}>
          {'Total credits'}
        </Typography>
        <Typography variant={'heading-lg'} ariaLabel={'TotalCreditsValue'}>
          {numberFormat({ value: summary.credits })}
        </Typography>
      </div>

      <div className={classNames(styles.cell, styles.cellSmall, styles.messagesIn)}>
        <Typography
          variant={'body-sm-regular'}
          color={'tertiary'}
          ariaLabel={'InboundMessagesLabel'}
        >
          {'Inbound'}
        </Typography>
        <Typography variant={'heading-sm'} ariaLabel={'InboundMessagesValue'}>
          {numberFormat({ value: summary.messages_inbound })}
        </Typography>
      </div>

      <div className={classNames(styles.cell, styles.cellSmall, styles.messagesOut)}>
        <Typography
          variant={'body-sm-regular'}
          color={'tertiary'}
          ariaLabel={'OutboundMessagesLabel'}
        >
          {'Outbound'}
        </Typography>
        <Typography variant={'heading-sm'} ariaLabel={'OutboundMessagesValue'}>
          {numberFormat({ value: summary.messages_outbound })}
        </Typography>
      </div>

      <div className={classNames(styles.cell, styles.cellSmall, styles.callsIn)}>
        <Typography variant={'body-sm-regular'} color={'tertiary'} ariaLabel={'InboundCallsLabel'}>
          {'Inbound'}
        </Typography>
        <Typography variant={'heading-sm'} ariaLabel={'InboundCallsValue'}>
          {numberFormat({ value: summary.calls_inbound })}
        </Typography>
      </div>

      <div className={classNames(styles.cell, styles.cellSmall, styles.callsOut)}>
        <Typography variant={'body-sm-regular'} color={'tertiary'} ariaLabel={'OutboundCallsLabel'}>
          {'Outbound'}
        </Typography>
        <Typography variant={'heading-sm'} ariaLabel={'OutboundCallsValue'}>
          {numberFormat({ value: summary.calls_outbound })}
        </Typography>
      </div>
    </div>
  )
})
